module.exports = __webpack_public_path__ + "static/ichk-47b905bb7aa73fd84523f57149a24a25.jpg";